import React from 'react';
import styles from './syncLoader.module.scss';
import SkeletonLoader from 'src/components/atomic/atoms/skeletonLoader/SkeletonLoader';
import PillLoader from 'src/components/atomic/atoms/pillLoader/PillLoader';
import { LoaderType } from 'src/types/loader-type.enum';
import { LoaderState } from 'src/types/loader-state.enum';
import { SyncLoaderViewModel } from 'src/types/view-models/sync-loader.view.model';
import budgetStyles from 'src/components/atomic/pages/budgets/budgetStyles.module.scss';
import { useSyncingAccounts } from 'src/hooks/useSyncingAccounts';

export default function SyncLoader({ type, className, loaderClassName, children }: SyncLoaderViewModel): JSX.Element {
    const { loaderState, isSyncingAccounts } = useSyncingAccounts();
    return (
        <div
            className={isSyncingAccounts ? `${styles.syncContainer} ${className}` : ''}
            aria-live="polite"
            aria-busy={isSyncingAccounts}
        >
            {loaderState === LoaderState.LOADING ? (
                type === LoaderType.PILL ? (
                    <PillLoader className={loaderClassName} />
                ) : (
                    <SkeletonLoader className={loaderClassName} />
                )
            ) : loaderState === LoaderState.FADE_IN ? (
                <div className={budgetStyles.fadeIn}>{children}</div>
            ) : (
                children
            )}
        </div>
    );
}
